
<template>
  <el-main>
    <el-card shadow="never">
      <div class="title">
        <span>{{ language("awaitDaily_dailyList.日期") }}：{{ ini() }}</span>
        <span class="day_num"
          >{{ language("awaitDaily_dailyList.最近7天")
          }}{{ language("awaitDaily_dailyList.未提交日报") }}{{ total }}</span
        >
      </div>
      <div class="input_box">
        <span>筛选：</span>
        <div class="input">
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="time"
            type="datetimerange"
            :range-separator="language('awaitDaily_dailyList.至')"
            :start-placeholder="language('awaitDaily_dailyList.开始日期')"
            :end-placeholder="language('awaitDaily_dailyList.结束日期')"
            :defaultTime="['00:00:00', '23:59:59']"
            size="mini"
          >
          </el-date-picker>
        </div>
        <div class="input">
          <el-cascader
            v-model="deptId"
            clearable
            :placeholder="language('awaitDaily_dailyList.部门')"
            size="mini"
            :options="classList"
            change-on-select
            :show-all-levels="false"
          >
          </el-cascader>
        </div>
        <div class="input">
          <el-select
            v-model="userId"
            size="mini"
            :placeholder="language('awaitDaily_dailyList.成员')"
            clearable
            filterable
          >
            <el-option
              v-for="(itmem, index) in user"
              :label="itmem.name"
              :value="itmem.id"
            ></el-option>
          </el-select>
        </div>
        <div class="input">
          <el-select
            v-model="submitStatus"
            clearable
            :placeholder="language('awaitDaily_dailyList.状态')"
            size="mini"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <el-button @click="doSearch" size="mini" type="primary">{{
          language("awaitDaily_dailyList.搜索")
        }}</el-button>
      </div>
    </el-card>
    <!--以下為cc-table-->
    <cc-table
      :loadData="true"
      :config="configTable"
      :params="paramsTable"
      :refeshParams="refeshTable"
      :autoButtonWidth="true"
      :buttonsWidth="60"
      ref="table"
    >
    </cc-table>
    <!---->

    <el-dialog
      :close-on-click-modal="false"
      :title="language('awaitDaily_dailyList.关闭日报')"
      :visible.sync="dialog"
      width="70%"
      append-to-body
    >
      <div>
        <h2>{{ language("awaitDaily_dailyList.请确认是否关闭此日报") }}</h2>
        <p>
          {{
            language("awaitDaily_dailyList.关闭之后该员工将无法填写日期日报")
          }}
        </p>
        <div class="userDay">
          <h3>
            {{ language("awaitDaily_dailyList.所在部门") }}：{{
              closeData.deptName
            }}
          </h3>
          <h3>
            {{ language("awaitDaily_dailyList.汇报人") }}：{{
              closeData.userName
            }}
          </h3>
          <h3>
            {{ language("awaitDaily_dailyList.日报日期") }}：{{
              getTime(closeData.dailyTime)
            }}
          </h3>
        </div>
        <div class="textarea">
          <el-input
            type="textarea"
            :rows="10"
            :placeholder="
              language('awaitDaily_dailyList.请输入关闭的原因说明比如：休假等')
            "
            v-model="closeData.remark"
          >
          </el-input>
        </div>
      </div>
      <div class="button_wrap">
        <el-button @click="dialog = false">{{
          language("awaitDaily_dailyList.取消")
        }}</el-button>
        <el-button type="primary" @click="doSubmit">{{
          language("awaitDaily_dailyList.提交")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="language('awaitDaily_dailyList.修改备注')"
      :visible.sync="dialogEdit"
      width="70%"
      append-to-body
    >
      <div>
        <!-- <h2>{{ language("awaitDaily_dailyList.请确认是否关闭此日报") }}</h2>
        <p>
          {{
            language("awaitDaily_dailyList.关闭之后该员工将无法填写日期日报")
          }}
        </p> -->
        <div class="userDay">
          <h3>
            {{ language("awaitDaily_dailyList.所在部门") }}：{{
              closeData.deptName
            }}
          </h3>
          <h3>
            {{ language("awaitDaily_dailyList.汇报人") }}：{{
              closeData.userName
            }}
          </h3>
          <h3>
            {{ language("awaitDaily_dailyList.日报日期") }}：{{
              getTime(closeData.dailyTime)
            }}
          </h3>
        </div>
        <div class="textarea">
          <el-input
            type="textarea"
            :rows="10"
            :placeholder="
              language('awaitDaily_dailyList.请输入关闭的原因说明比如：休假等')
            "
            v-model="closeData.remark"
          >
          </el-input>
        </div>
      </div>
      <div class="button_wrap">
        <el-button @click="dialog = false">{{
          language("awaitDaily_dailyList.取消")
        }}</el-button>
        <el-button type="primary" @click="doSubmit">{{
          language("awaitDaily_dailyList.提交")
        }}</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<script>
import Vue from "vue";
import submitStatus from "./components/items/submitStatus.vue";
import moment from "moment";

export default {
  data() {
    return {
      searchConfig: [],

      refeshTable: -1,
      paramsTable: {
        startTime: this.$timeUtils.getNDay(-6) + " 00:00:00",
        endTime: this.$timeUtils.getYMMHMS(" 23:59:59"),
      },

      configTable: {
        api: "admin/fsb/workshop/daily/unSubmitWorkshopDaily",
        showPager: true,
        columns: [
          {
            prop: "deptName",
            lable: this.language("awaitDaily_dailyList.部门"),
            minWidth: 100,
          },
          {
            prop: "userName",
            lable: this.language("awaitDaily_dailyList.提交人"),
            minWidth: 100,
          },
          {
            prop: "dailyTime",
            lable: this.language("awaitDaily_dailyList.日报日期"),
            minWidth: 160,
            render: (rows) => {
              if (rows.dailyTime) {
                return moment(rows.dailyTime).format("YYYY-MM-DD");
              }
            },
          },
          // {
          //   prop: "submitStatus",
          //   lable: this.language("awaitDaily_dailyList.状态"),
          //   minWidth: 100,
          //   render: (e) => {
          //     if (e.isEnabled == 1) {
          //       return this.language("awaitDaily_dailyList.已关闭");
          //     } else {
          //       if (e.submitStatus == 0) {
          //         return this.language("awaitDaily_dailyList.未提交");
          //       }
          //     }
          //   },
          // },
          {
            type: "component",
            prop: "submitStatus",
            lable: this.language("awaitDaily_dailyList.状态"),
            minWidth: 100,
            componentName: submitStatus,
          },
          {
            prop: "remark",
            lable: this.language("awaitDaily_dailyList.备注"),
            minWidth: 150,
            render: (row) => {
              if (row.isSubmit == 0) {
                return "超过7天不可填写";
              } else {
                return row.remark;
              }
            },
          },
        ],
        buttons: [
          {
            name: this.language("awaitDaily_dailyList.关闭"),
            click: (row) => {
              this.closeData = row;
              this.dialog = true;
              this.from = {};
            },
            check: (e) => {
              let type = false;
              if (e.submitStatus == 2) {
                type = false;
              } else {
                if (e.submitStatus == 0) {
                  // type = true;
                  if (e.dailyTime) {
                    let time = new Date().getTime();
                    let dailyTime =
                      new Date(e.dailyTime.replace(/\-/g, "/")).getTime() +
                      604800000;
                    if (time < dailyTime) {
                      type = true;
                    }
                  }
                }
              }

              return type;
            },
          },
          {
            name: this.language("awaitDaily_dailyList.修改备注"),
            click: (row) => {
              this.closeData = row;
              this.dialogEdit = true;
              this.from = {};
            },
            check: (e) => {
              if (e.submitStatus == 2) {
                return true;
              } else {
                if (e.submitStatus == 0) {
                  return false;
                }
              }
            },
          },
        ],
      },

      options: [
        {
          value: 2,
          label: this.language("awaitDaily_dailyList.已关闭"),
        },
        {
          value: 0,
          label: this.language("awaitDaily_dailyList.未提交"),
        },
        {
          value: 100,
          label:
            this.language("awaitDaily_dailyList.未提交") +
            "(" +
            this.language("awaitDaily_dailyList.退回") +
            ")",
        },
      ],
      classList: [],
      time: [
        this.$timeUtils.getNDay(-6) + " 00:00:00",
        this.$timeUtils.getYMMHMS(" 23:59:59"),
      ],
      deptId: "",
      submitStatus: "",
      userId: "",
      user: [],
      total: 0,
      dialog: false,
      dialogEdit: false,
      closeData: {},
    };
  },
  methods: {
    getTime(e) {
      return moment(e).format("YYYY-MM-DD");
    },
    ini() {
      let time = new Date();
      let y = time.getFullYear();
      let m = this.count(time.getMonth() + 1);
      let d = this.count(time.getDate());
      return (
        y +
        this.language("awaitDaily_dailyList.年") +
        m +
        this.language("awaitDaily_dailyList.月") +
        d +
        this.language("awaitDaily_dailyList.日")
      );
    },
    count(n) {
      return n < 10 ? "0" + n : n;
    },
    //搜索
    doSearch(e) {
      this.paramsTable = {};
      if (this.time && this.time.length > 0) {
        this.paramsTable.startTime = this.time[0];
        this.paramsTable.endTime = this.time[1];
      }
      if (this.deptId.length > 0) {
        this.paramsTable.deptId = this.deptId[this.deptId.length - 1];
      }
      if (this.userId) {
        this.paramsTable.userId = this.userId;
      }
      delete this.paramsTable.submitStatus;
      delete this.paramsTable.isAudit;

      if (this.submitStatus === 2) {
        this.paramsTable.submitStatus = 2;
      }

      if (this.submitStatus === 0) {
        this.paramsTable.submitStatus = 0;
      }

      if (this.submitStatus === 100) {
        this.paramsTable.isAudit = 2;
      }
      this.getTable();
    },
    initClassList(data) {
      for (let i in data) {
        data[i].label = data[i].fullname;
        data[i].value = data[i].id;
        if (data[i].children.length > 0) {
          this.initClassList(data[i].children);
        } else {
          delete data[i].children;
        }
      }
    },
    getClassList() {
      this.ccRequest
        .do("admin/fsb/workshop/unit/getSubDeptListByRole", {}, "GET")
        .then((res) => {
          this.classList = res;
          this.initClassList(this.classList);
          console.log(this.classList);
        });
    },

    getUser() {
      this.ccRequest
        .do(
          "admin/fsb/workshop/unit/getWorkshopStaff",
          { pageSize: 2000 },
          "GET"
        )
        .then((res) => {
          this.user = res;
        });
    },
    getTable() {
      this.ccRequest
        .do(
          "admin/fsb/workshop/daily/unSubmitWorkshopDaily",
          {
            startTime: this.$timeUtils.getNDay(-6) + " 00:00:00",
            endTime: this.$timeUtils.getYMMHMS(" 23:59:59"),
            submitStatus: 0,
          },
          "GET"
        )
        .then((res) => {
          this.total = res.total;
        });
    },
    doSubmit() {
      if (!this.closeData.remark || this.closeData.remark == "") {
        this.$message.error(this.language("awaitDaily_dailyList.请先输入备注"));
        return false;
      }
      let data = {
        dailyId: this.closeData.id,
        remark: this.closeData.remark,
      };
      this.ccRequest
        .do("admin/fsb/workshop/daily/closeWorkshopDailyById", data, "GET")
        .then((res) => {
          this.$message.success(this.language("awaitDaily_dailyList.操作成功"));
          this.dialogEdit = false;
          this.dialog = false;
          this.refeshTable = new Date().getTime();
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
  },
  mounted() {
    this.getClassList();
    this.getUser();
    this.getTable();
  },
};
</script>
<style lang="scss" scoped>
.title {
  font-weight: 700;
  font-size: 18px;
}
.input_box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  span {
    font-weight: 700;
  }
}
.input {
  margin: 10px 20px 10px 0;
}
p,
h2,
h3 {
  text-align: center;
}
h2 {
  margin-bottom: 10px;
}
.userDay {
  margin-top: 40px;
}

h3 {
  margin-bottom: 5px;
}
.textarea {
  width: 80%;
  margin: 20px auto 0 auto;
}
.button_wrap {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.day_num {
  margin: 0 0 0 40px;
}
</style>